let scrollY = 0;

function toggleCart() {
  const container = document.querySelector('#CartContainer')
  const header = document.querySelector('.sticky-header')

  if (container.classList.contains('is-open')) {
    container.querySelector('.cart').style.transform = 'translateX(100%)'

    setTimeout(() => {
      container.classList.remove('is-open')

      document.body.style.overflow = ''
      document.body.style.height = ''
      document.body.style.position = ''
      document.body.style.top = ''

      // restore header
      header.style.position = ''
      header.style.top = ''
      header.style.width = ''
      header.style.zIndex = ''

      window.scrollTo(0, scrollY)

      document.body.classList.remove('upcartPopupShow')
    }, 350)

  } else {
    scrollY = window.scrollY

    container.classList.add('is-open')

    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollY}px`
    document.body.style.width = '100%'

    // force header to stay visible
    header.style.position = 'fixed'
    header.style.top = '0'
    header.style.width = '100%'
    header.style.zIndex = '9999'

    setTimeout(() => {
      container.querySelector('.cart').style.transform = 'translateX(0%)'
    }, 0)
  }
}

let productObserver = null
let hasSetupListener = false

// Clicking #AddToCart clicks the form's submit button (#AddToCartKlaviyo), so
// AddToCartForm is submitted and whoever handles it adds the product:
// - Cleat Product Options (monogram add-on) takes the submit, adds the product +
//   add-on itself, then calls Shopify.actions.updateCart (handled below)
// - otherwise the theme's onAddToCart (theme.min.js), or this file when nobody does
// Once the add has finished, the free gift and selected extension products are
// added, then CartJS.getCart() fires `cart.requestComplete`, which
// script-free-gift.js uses to refresh #CartContainer and open the drawer.
function getExtraItems() {
  const items = [];

  const freeGiftId = document.querySelector('product-free-gift')?.getAttribute('data-gift-id');
  if (freeGiftId) {
    items.push({ id: freeGiftId, quantity: 1 });
  }

  document
    .querySelectorAll(
      '.product-extension-item__product-variant.selected:not(.product-extension-item__product-variant-none)'
    )
    .forEach((extensionProduct) => {
      const variantID = extensionProduct.getAttribute('data-variant');
      if (!variantID) return;

      const extensionItem = { id: variantID, quantity: 1 };

      if (extensionProduct.querySelector('.product-extension-item__pre-order')) {
        extensionItem.properties = {
          PreOrder:
            extensionProduct.querySelector('.product-extension-item__pre-order-date')?.textContent ||
            'Ship date will be updated.',
        };
      }

      items.push(extensionItem);
    });

  return items;
}

// For an #AddToCart that isn't inside a form (e.g. page.hybrid-laptop-sleeve-v2)
function getStandaloneFormData() {
  const formData = new FormData();
  formData.append('id', document.querySelector('select[name="id"]')?.value || '');
  formData.append('quantity', '1');

  const preorderValue = document.querySelector('input[name="properties[PreOrder]"]')?.value;
  if (preorderValue) formData.append('properties[PreOrder]', preorderValue);

  return formData;
}

function postCartAdd(body) {
  const isFormData = body instanceof FormData;

  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: isFormData
      ? { Accept: 'application/json' }
      : { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: isFormData ? body : JSON.stringify(body),
  }).then(async (response) => {
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');
    return data;
  });
}

function isAddToCartDisabled(addToCartBtn) {
  return (
    addToCartBtn.disabled ||
    addToCartBtn.hasAttribute('disabled') ||
    addToCartBtn.classList.contains('disabled') ||
    addToCartBtn.classList.contains('adding')
  );
}

function stopAdding(addToCartBtn) {
  setTimeout(() => {
    addToCartBtn.classList.remove('adding');
  }, 300);
}

function addExtrasAndOpenCart(addToCartBtn) {
  const extraItems = getExtraItems();

  (extraItems.length ? postCartAdd({ items: extraItems }) : Promise.resolve())
    .catch((err) => {
      console.error('Adding gift / extension products failed:', err);
    })
    .finally(() => {
      CartJS.getCart();
      stopAdding(addToCartBtn);
    });
}

// The theme's onAddToCart posts the form to /cart/add.js, then fetches
// /cart?view=compare once the add succeeded. Watch for those to know when it's done.
let pendingFormAdd = null;

(function (originalFetch) {
  window.fetch = function (resource) {
    const response = originalFetch.apply(this, arguments);
    if (!pendingFormAdd) return response;

    const url = typeof resource === 'string' ? resource : resource?.url || '';

    response
      .then((res) => {
        if (!pendingFormAdd) return;

        if (url.includes('/cart/add') && !res.ok) {
          const addToCartBtn = pendingFormAdd.button;
          clearPendingFormAdd();
          stopAdding(addToCartBtn);
        } else if (url.includes('view=compare')) {
          const addToCartBtn = pendingFormAdd.button;
          clearPendingFormAdd();
          addExtrasAndOpenCart(addToCartBtn);
        }
      })
      .catch(() => {});

    return response;
  };
})(window.fetch);

function clearPendingFormAdd() {
  if (!pendingFormAdd) return;
  clearTimeout(pendingFormAdd.timeout);
  pendingFormAdd = null;
}

function startPendingFormAdd(addToCartBtn) {
  clearPendingFormAdd();
  addToCartBtn.classList.add('adding');

  pendingFormAdd = {
    button: addToCartBtn,
    // Safety net in case the theme's add never reports back
    timeout: setTimeout(() => {
      clearPendingFormAdd();
      stopAdding(addToCartBtn);
    }, 10000),
  };
}

// For an #AddToCart that isn't inside a form (e.g. page.hybrid-laptop-sleeve-v2)
function addStandaloneToCart(addToCartBtn) {
  const formData = getStandaloneFormData();
  if (!formData.get('id')) return;

  addToCartBtn.classList.add('adding');

  postCartAdd(formData)
    .then(() => addExtrasAndOpenCart(addToCartBtn))
    .catch((err) => {
      console.error('Add to cart failed:', err);
      stopAdding(addToCartBtn);
    });
}

// Shopify.actions (standard-actions.js) is what Cleat calls after adding. Left
// unconfigured it reloads the page because this theme has no Dawn cart components.
function configureShopifyCartActions() {
  const actions = window.Shopify?.actions;
  if (!actions?.updateCart?.configure) return;

  actions.updateCart.configure({
    handler: async (update) => {
      const addToCartBtn = pendingFormAdd?.button;
      clearPendingFormAdd();

      try {
        const result = await update();

        if (addToCartBtn) {
          addExtrasAndOpenCart(addToCartBtn);
        } else {
          CartJS.getCart();
        }

        return result;
      } catch (err) {
        if (addToCartBtn) stopAdding(addToCartBtn);
        throw err;
      }
    },
  });

  actions.openCart.configure({
    handler: () => {
      if (!document.querySelector('#CartContainer')?.classList.contains('is-open')) toggleCart();
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  configureShopifyCartActions();

  // AddToCartForm submitted and not taken over by Cleat. Listeners on the form
  // itself (theme's onAddToCart) have already run by the time it bubbles up here.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.id !== 'AddToCartForm') return;

    const addToCartBtn = form.querySelector('#AddToCart');
    if (!addToCartBtn) return;

    // The theme's onAddToCart took the submit: wait for it to finish
    if (event.defaultPrevented) {
      if (pendingFormAdd?.button !== addToCartBtn) startPendingFormAdd(addToCartBtn);
      return;
    }

    // Nobody handled it: stop the page reload and post the form ourselves
    event.preventDefault();
    clearPendingFormAdd();
    addToCartBtn.classList.add('adding');

    postCartAdd(new FormData(form, event.submitter))
      .then(() => addExtrasAndOpenCart(addToCartBtn))
      .catch((err) => {
        console.error('Add to cart failed:', err);
        stopAdding(addToCartBtn);
      });
  });

  document.addEventListener('click', (event) => {
    const addToCartBtn = event.target.closest('#AddToCart');
    if (!addToCartBtn) return;

    const form = addToCartBtn.closest('form');
    const isSubmitButton = !!form && addToCartBtn.matches('button[type="submit"]');

    if (isAddToCartDisabled(addToCartBtn)) {
      event.preventDefault();
      return;
    }

    if (!form) {
      event.preventDefault();
      addStandaloneToCart(addToCartBtn);
      return;
    }

    startPendingFormAdd(addToCartBtn);

    // A real submit button submits the form by itself
    if (isSubmitButton) return;

    event.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"]#AddToCartKlaviyo');
    if (submitBtn) {
      submitBtn.click();
    } else {
      form.requestSubmit();
    }
  });

  document
    .querySelectorAll('.site-header__cart-toggle, .cart__underlay, .close-cart')
    .forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        toggleCart();
      });
    });
});

if (!customElements.get('open-cart')) {
  customElements.define('open-cart', class OpenCart extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', () => {
        toggleCart()
      })
    }
  })
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', class CartItem extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.price-remove .remove').addEventListener('click', (event) => {
        event.target.classList.add('free-gift-loading')

        CartJS.removeItem(event.target.closest('cart-item').getAttribute('data-line'), {
          success: function(data, textStatus, jqXHR) {
            //console.log('Item successfully removed');
            if (event.target.closest('cart-item').classList.contains('has-monogramming')) {
              setTimeout(function(){
                fetchCart();
              }, 20);
            }
          },
          error: function(jqXHR, textStatus, errorThrown) {
            //console.error('Error removing item:', errorThrown);
          }
        })
      })

      this.querySelector('.qty-wrapper .minus').addEventListener('click', () => {
        this.querySelector('input').stepDown()
        this.updateQuantity()
      })
      this.querySelector('.qty-wrapper .plus').addEventListener('click', () => {
        this.querySelector('input').stepUp()
        this.updateQuantity()
      })
    }

    timeout = null

    updateQuantity() {
      if (this.timeout) {
        return
      }

      this.timeout = setTimeout(() => {
        this.querySelector('.price-remove .remove').classList.add('free-gift-loading')
        CartJS.updateItem(this.getAttribute('data-line'), this.querySelector('input').value)
        this.timeout = null
      }, 300)
    }
  })
}

if (!customElements.get('cart-header')) {
  customElements.define('cart-header', class CartHeader extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.close-cart').addEventListener('click', event => {
        toggleCart()
      })
    }
  })
}


let previousCartState = null;
// Fetch the current cart data
function fetchCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(currentCart => {
      if (previousCartState) {
        checkForRemovedItems(previousCartState, currentCart);
      }
      syncCartAttributes(currentCart);
      previousCartState = currentCart; // Update the previous cart state
    });
}

// Poll the cart periodically to detect changes
setInterval(fetchCart, 5000);

function getDiscountedItems(cart) {
  return cart.items
    .filter(item => {
      if (!item.discounts || item.discounts.length === 0) return false;

      return item.discounts.some(discount => {
        const title = discount.title.toLowerCase();
        return title.includes('free');
      });
    })
    .map(item => item.product_id);
}

function syncCartAttributes(cart) {
  // 1. Build discount_freegift string
  const ids = getDiscountedItems(cart);
  const discountFreeGift = ids.join(',');
  // 2. Compare total_discount
  const currentTotalDiscount = cart.total_discount || 0;
  const attrTotalDiscount = Number(cart.attributes?.total_discount || 0);

  // 3. Prepare new attributes object
  const newAttributes = { ...cart.attributes };
  let needUpdate = false;

  if (!newAttributes.discount_freegift) newAttributes.discount_freegift = '';
  if (newAttributes.discount_freegift !== discountFreeGift) {
    newAttributes.discount_freegift = discountFreeGift;
    needUpdate = true;
  }

  if (currentTotalDiscount !== attrTotalDiscount) {
    newAttributes.total_discount = String(currentTotalDiscount);
    needUpdate = true;
  }

  // 4. Update if needed
  if (needUpdate) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: newAttributes })
    })
    .then(res => res.json())
    .then(updatedCart => {
      console.log('Cart attributes synced:', updatedCart.attributes);
    });
  }
}

// Compare the previous cart with the current one to find removed items
function checkForRemovedItems(prevCart, currCart) {
  const prevItems = prevCart.items.map(item => item.key);
  const currItems = currCart.items.map(item => item.key);

  // Find the item(s) removed by comparing the two arrays
  const removedItems = prevItems.filter(key => !currItems.includes(key));

  if (removedItems.length > 0) {
    removedItems.forEach(removedItem => {
      // Find the full item details by variant_id from the previous cart
      const removedItemDetails = prevCart.items.find(item => item.key === removedItem);
      
      if (removedItemDetails.properties['Has Monogramming'] == 'Yes') {
        // KO with Monogramming removed
        const propertiesToRemove = {
          'Key Organiser': removedItemDetails.title,
          'Initials (Capital letters only)*': removedItemDetails.properties['Initials (Capital letters only)*'],
        };
        removeItemByProperties(propertiesToRemove);
      } else if (removedItemDetails.properties['Initials (Capital letters only)*'] != '') {
        // Monogramming removed
        const propertiesToRemove = {
          'Has Monogramming': 'Yes',
          'Initials (Capital letters only)*': removedItemDetails.properties['Initials (Capital letters only)*'],
        };
        const newProperties = {
          'Has Monogramming': 'No',
        }; // Clear old properties
        updateItemProperties(propertiesToRemove,newProperties);
      }
    });
  }
}

function updateItemProperties(properties,newProperties) {
  // Fetch the current cart data
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Iterate through the cart items
      cart.items.forEach((item,index) => {
        // Check if the item has the specified properties
        const matchesAllProperties = Object.keys(properties).every(propertyName => {
          return item.properties && item.properties[propertyName] === properties[propertyName];
        });

        // If all properties match, remove the item's properties
        if (matchesAllProperties) {
          //console.log(item);
          updateCartItemPropertiees(item.key, newProperties)
          setTimeout(function(){
            CartJS.updateItem(index+1, item.quantity);
          },1000);
        }
      });
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

function removeItemByProperties(properties) {
  // Fetch the current cart data
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Iterate through the cart items
      cart.items.forEach(item => {
        // Check if the item has the specified properties
        const matchesAllProperties = Object.keys(properties).every(propertyName => {
          return item.properties && item.properties[propertyName] === properties[propertyName];
        });
        // If all properties match, remove the item
        if (matchesAllProperties) {
          //console.log(item);
          CartJS.removeItemById(item.key);
        }
      });
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

// Remove the item from the cart by variant ID or line ID
function updateCartItemPropertiees(key, properties) {
  let data = {
      "id" : key,
      "properties" : properties
  }
  let cartContents = fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
  })
  .then(response => {
      return response.json();
  })
  .then(cart => {
    // Optionally, refresh the cart UI or trigger custom events here
  })
  .catch((error) => {
      console.error('Error:', error);
  })
}

// Remove the item from the cart by variant ID or line ID
function removeCartItem(key) {
  let data = {
      "id" : key,
      "quantity" : 0
  }
  console.log(data);

  let cartContents = fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
  })
  .then(response => {
      return response.json();
  })
  .then(cart => {
    // Optionally, refresh the cart UI or trigger custom events here
  })
  .catch((error) => {
      console.error('Error:', error);
  })
}

(function () {
  const paymentButtonSelector = '[data-shopify="payment-button"]';
  const radioSelector = '#bold_options_div input[type="radio"]';

  function togglePaymentButton() {
    const paymentButton = document.querySelector(paymentButtonSelector);
    const checkedRadio = document.querySelector(`${radioSelector}:checked`);
    
    if (!paymentButton || !checkedRadio) return;

    paymentButton.style.display = checkedRadio.value !== 'No' ? 'none' : '';
  }

  function bindRadioListeners() {
    const radios = document.querySelectorAll(radioSelector);
    if (!radios.length) return false;

    radios.forEach(radio => {
      if (!radio.dataset.paymentToggleBound) {
        radio.addEventListener('change', togglePaymentButton);
        radio.dataset.paymentToggleBound = '1';
      }
    });

    togglePaymentButton();
    return true;
  }

  // Observe DOM changes
  const observer = new MutationObserver(() => {
    if (bindRadioListeners()) {
      // Optional: stop observing once radios exist
      // observer.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
